import React, { useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import Loader from "../Utilities/Loader";

export default function AddTechnology({
  technologyData,
  addTechnology,
  techType,
  editData,
  closeModal,
}) {
  const [toggle, setToggle] = useState(false);
  const [techId, setTechId] = useState("");
  const [version, setVersion] = useState("");
  const [note, setNote] = useState("");
  const [reason, setReason] = useState("");
  const toggleClass =
    " transform translate-x-5 transition delay-150 duration-150 ease-linear";
  const [isUpdateLoading, setUpdateLoading] = useState(false);

  const filterdTechnologyData = technologyData.filter((techitem) => {
    if (techitem.type === techType) {
      return techitem;
    }
  });

  const submitData = async () => {
    try {
      let newtechnologyname = "";
      let technicalid = "";
      const filteredData = filterdTechnologyData.filter((item) => {
        return item._id === techId.value;
      });

      if (filteredData.length > 0) {
        technicalid = filteredData[0]._id;
        newtechnologyname = "";
      } else {
        newtechnologyname = techId.value;
        technicalid = "";
      }
      setUpdateLoading(true);
      const responseData = await addTechnology(
        {
          techId: technicalid,
          version,
          note,
          reason,
          newtechnologyname,
          status: toggle,
          platform: techType,
        },
        editData
      );
      setUpdateLoading(false);
    } catch (err) {
      setUpdateLoading(false);
    }
  };

  useEffect(() => {
    if (editData) {
      setToggle(editData.status);
      setTechId({ label: editData.techId.name, value: editData.techId._id });
      setVersion(editData.version);
      setNote(editData.note);
      setReason(editData.reason);
    } else {
      setToggle(true);
    }
  }, [editData]);

  return (
    <div className="rounded-xl">
      <div className="rounded-xl">
        <div className="text-theme-fg-1 font-medium block mr-5 text-xl mb-4">
          {" "}
          {techType === "server" ? "Server  Side" : "Client Side"}{" "}
        </div>

        <CreatableSelect
          className="mb-3 transition delay-150 duration-150 ease-linear border rounded-theme-sm w-full placeholder-theme-fg-3 text-theme-fg-1 font-normal border-theme-cream-3 text-sm"
          name="client"
          value={techId}
          isSearchable={true}
          isClearable={true}
          classNamePrefix="dropdownSelect"
          options={filterdTechnologyData.map((project) => ({
            label: project.name,
            value: project._id,
          }))}
          placeholder="Technology Name"
          onChange={(e) => setTechId(e)}
        />

        {/* <input type="text" name="" placeholder="Node" className="mb-7 focus:outline-none focus:border-theme-accent transition delay-150 duration-150 ease-linear text-base border rounded-md py-2 px-4  w-full placeholder-theme-fg-3 text-theme-fg-3 font-normal border-theme-cream-3" /> */}
        <input
          value={version}
          onChange={(evt) => {
            setVersion(evt.target.value);
          }}
          type="text"
          name=""
          placeholder="Version"
          className="mb-3 focus:outline-none focus:border-theme-accent transition delay-150 duration-150 ease-linear text-sm border rounded-theme-sm py-2 px-4  w-full placeholder-theme-fg-3 text-theme-fg-1 font-normal border-theme-cream-3"
        />
        <textarea
          placeholder="Description"
          value={note}
          onChange={(evt) => {
            setNote(evt.target.value);
          }}
          className="mb-3 focus:outline-none focus:border-theme-accent transition delay-150 duration-150 ease-linear text-sm border rounded-theme-sm py-2 px-4  w-full placeholder-theme-fg-3 text-theme-fg-1 font-normal border-theme-cream-3 h-28 resize-none"
        ></textarea>
        <div className="mb-3 text-sm flex items-center text-theme-fg-2 font-medium">
          Currently Using
          <div
            onClick={() => {
              setToggle(!toggle);
            }}
            className={`flex items-center rounded-theme-pill p-1 cursor-pointer ml-4 md:w-10 md:h-5 w-10 h-5  ${
              toggle ? "bg-theme-avail-fg" : "bg-theme-cream-3"
            }`}
          >
            <div
              className={`bg-theme-paper md:w-3 md:h-3 h-3 w-3 rounded-theme-pill shadow-theme-card transform " +  ${
                toggle ? toggleClass : null
              }`}
            ></div>
          </div>
        </div>
        {/* {toggle === false ?
                    <input value={reason} onChange={(evt) => {
                        setReason(evt.target.value);
                    }} type="text" name="" placeholder="Reason" className="mb-7 focus:outline-none focus:border-theme-accent transition delay-150 duration-150 ease-linear text-base border rounded-md py-3 px-4  w-full placeholder-theme-fg-3 text-theme-fg-3 font-normal border-theme-cream-3" />
                    : " "} */}
        <div className="flex items-end justify-end w-full">
          <button
            disabled={isUpdateLoading}
            onClick={() => {
              submitData();
            }}
            className="px-14 font-title h-11 bg-theme-ink text-white text-sm font-semibold transition duration-300 ease-out hover:bg-theme-ink-2 rounded-theme-sm"
          >
            Set
            {isUpdateLoading ? <Loader /> : null}
          </button>
        </div>
      </div>
    </div>
  );
}
